'use strict';

class CCheckboxController{
  constructor(){

  }
  $onInit(){

  }
}
export default CCheckboxController;



// WEBPACK FOOTER //
// ./src/app/common/core/util/c-components-bootstrap/c-checkbox/c-checkbox.controller.js